export default "__VITE_ASSET__Carzll$R__"